<template>
<div>
  <div class="form-group">
    <label class="control-label">{{ $t('Activity') }}</label>
    <select
        v-model="selectedActivity"
        class="form-control"
        name="activitySelected"
        id="activitySelected"
    >
      <option
          v-for="activity in activitiesSelectList"
          :value="activity.id"
      >{{ activity.code }}
      </option>
    </select>
  </div>
  <hr>
  <div class="tw:flex tw:items-center tw:justify-between">
    <button
        @click.prevent="selectAll = true; selectAllVariants(activitySelected)"
        class="btn btn-outline-success tw:flex tw:items-center"
        :disabled="!this.activitySelected"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
           class="bi bi-check-all" viewBox="0 0 16 16">
        <path
            d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"></path>
      </svg>
      {{ $t('Select All') }}
    </button>
    <button @click.prevent="selectAll = false; selectAllVariants(activitySelected)"
            class="btn btn-outline-danger tw:flex tw:items-center"
            :disabled="!this.activitySelected"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
           class="bi bi-check-all" viewBox="0 0 16 16">
        <path
            d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"></path>
      </svg>
      {{ $t('Unselect All') }}
    </button>
  </div>
  <hr>
  <h5>{{ $t('Variants list') }}</h5>

  <div class="overflow-auto" style="max-height: 300px">
    <div class="form-check"
         v-for="variant in activitySelectedVariants"
         :key="variant.id"
         style="justify-content:center"
    >
      <div class="mt-1 ml-1 mr-1 mb-1">
        <input type="checkbox"
               :id="variant.id"
               v-model="variantsSelectedList"
               class="form-check-input"
               :value="variant.id"
               @change="emitVariantsSelectedList"
        >
        <label :for="variant.id">
          <template v-if="activitySelected.options.length > 0">
            <span v-for="activityOption in activitySelected.options" :key="activityOption.id" class="badge badge-light mr-1">
                  {{ activityOption.code }} :
                  {{ variant.option_values.find((optionValue) => optionValue.activity_option_id === activityOption.id)?.code ?? 'N/A' }}
            </span>
          </template>
          <template v-else>
            <span :key="variant.id" class="badge badge-light mr-1">
              {{ activitySelected.code }}
            </span>
          </template>
        </label>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    variantsSelected: {
      type: Array,
      default: function () {
        return [];
      }
    },
    activitiesSelectList: {
      required: true,
      type: Array,
    },
    activityDefault: {
      type: Number,
      default : 0,
    },
  },
  data() {
    return {
      selectedActivity: 0,
      variantsSelectedList: this.variantsSelected ?? [],
      selectAll: false,
    }
  },
  watch: {
    activityDefault: function (val) {
      this.selectedActivity = val
    },
    variantsSelected: function (val) {
      this.variantsSelectedList = val
    },
  },
  methods: {
    emitVariantsSelectedList() {
      this.$emit('change-variants-list', this.variantsSelectedList)
    },
    selectAllVariants(activity) {
      let vm = this
      if (this.activitySelected) {
        if (this.selectAll) {
          activity.variants.forEach(function (variant) {
            if (vm.variantsSelectedList.indexOf(variant.id) === -1) {
              // si le variant n'est pas déjà dans la liste des variants selectionnés j'ajoute
              vm.variantsSelectedList.push(variant.id)
            }
          })
          vm.emitVariantsSelectedList()
        } else {
          activity.variants.forEach(function (variant) {
            if (vm.variantsSelectedList.indexOf(variant.id) > -1) {
              // si le variant existe dans la liste des variants selectionnés je supprime
              vm.variantsSelectedList.splice(vm.variantsSelectedList.indexOf(variant.id), 1)
            }
          })
          vm.emitVariantsSelectedList()
        }
      }
    },
  },
  computed: {
    activitySelected() {
      if (this.activitiesSelectList && this.selectedActivity) {
        return this.activitiesSelectList.find(activity => activity.id === parseInt(this.selectedActivity))
      }
    },
    activitySelectedVariants() {
      if (this.activitySelected) {
        return this.activitySelected.variants;
      }
    },
  },
  mounted() {
    if (this.variantsSelectedList.length > 0) {
      this.selectedActivity = this.activitiesSelectList.find(activity => activity.variants.find(variant => {
        if (this.variantsSelectedList.indexOf(variant.id) > -1) {
          this.selectedActivity = activity.id
          return true
        }
      })).id || null
    }
  }
}
</script>

<style scoped>

</style>